import { Component, Prop, Vue } from 'vue-property-decorator';
import { toCamel, toSnake } from 'snake-camel';
import WidgetHeader from './WidgetHeader/WidgetHeader.vue'
import WidgetContentIncomeAndOutgoAgriFieldGroupPart from '@/components/Dashboard/Widgets/Widget/WidgetContent/WidgetContentIncomeAndOutgoAgriFieldGroupPart/WidgetContentIncomeAndOutgoAgriFieldGroupPart.vue'
import WidgetContentPlantingBudgetAndActualResultsPart from '@/components/Dashboard/Widgets/Widget/WidgetContent/WidgetContentPlantingBudgetAndActualResultsPart/WidgetContentPlantingBudgetAndActualResultsPart.vue'
import { WidgetData } from '@/components/Dashboard/Widgets/types/Widget';
import { AbstractWidgetContent } from '../AbstractWidget/AbstractWidget';
import WidgetConfig from '@/components/Dashboard/Widgets/WidgetConfig/WidgetConfig.vue';

@Component({
    components: {
        WidgetHeader,
        WidgetContentIncomeAndOutgoAgriFieldGroupPart,
        WidgetContentPlantingBudgetAndActualResultsPart,
        WidgetConfig
    }
})
export default class Widget extends Vue {
    private config!: any;
    private showConfigModal = false

    @Prop()
    private widgetData!: WidgetData

    private camelWidgetData!: WidgetData

    created(): void {
        this.widgetData.config = toCamel(JSON.parse(this.widgetData.config))
        this.camelWidgetData = toCamel(this.widgetData) as WidgetData
    }

    get refHeader(): any {
        return this.$refs.header as any
    }

    get refContent(): AbstractWidgetContent<any> {
        return this.$refs.content as AbstractWidgetContent<any>;
    }

    private openConfig() {
        this.$emit('openConfig', this.camelWidgetData)
    }

    public async closeConfig(instance: WidgetData): Promise<void> {
        const data = {
            title: instance.title,
            config: JSON.stringify(toSnake(instance.config))
        }
        await this.$apiClient.doRequest('put', `/admin/widget_instances/${instance.id}`, data)
            .then(() => {
                this.$emit('closeModal')
                this.camelWidgetData = instance
                this.refHeader.updateInstance(instance)
                this.$toasted.success('保存しました。')
                this.refresh(instance)
            })
            .catch(() => {
                this.$toasted.error('保存に失敗しました。')
            })
    }

    // ヘッダーの更新ボタンが押されたとき、動的子コンポーネントのrefresh()を呼ぶ
    private refresh(widgetData: WidgetData) {
        this.refContent.refresh(widgetData)
    }
}